import { render } from "./BrNavigation.vue?vue&type=template&id=0e2546c4&scoped=true"
import script from "./BrNavigation.vue?vue&type=script&lang=js"
export * from "./BrNavigation.vue?vue&type=script&lang=js"

import "./BrNavigation.vue?vue&type=style&index=0&id=0e2546c4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e2546c4"]])

export default __exports__